import React from "react";

export default function  List({
  children,
  className,
}) {
  return <div className={`w-100 ${className}`}>
      {children}
  </div>
};
